import { useCallback, useEffect, useState } from 'react';
import { ChartData } from 'types';

export const useChart = () => {
    const [data, setData] = useState<ChartData[]>([]);
    const [targetIncome, setTargetIncome] = useState(0);
    const [totalIncome, setTotalIncome] = useState(0);

    const updateChartData = useCallback((label: string, newValue: number) => {
        setData(prevData => prevData.map(item => (item.label === label ? { ...item, y: newValue } : item)));
    }, []);

    const addChartData = useCallback((dataPoint: ChartData) => {
        setData(prevData => [...prevData, dataPoint]);
    }, []);

    const removeChartData = useCallback((label: string) => {
        setData(prevData => prevData.filter(item => item.label !== label));
    }, []);

    const updateTargetIncome = useCallback((value: number) => {
        setTargetIncome(value);
    }, []);

    const resetChartData = useCallback(() => {
        setData([]);
    }, []);

    useEffect(() => {
        setTotalIncome(data.filter(item => item.label !== 'Shortfall').reduce((acc, item) => acc + Number(item.y), 0));
    }, [data]);

    return {
        data,
        updateChartData,
        targetIncome,
        totalIncome,
        updateTargetIncome,
        resetChartData,
        addChartData,
        removeChartData,
    };
};
